import React from "react"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import ReactHtmlParser from "react-html-parser"

function ImageHero({
  preHeaderText,
  boldHeadline,
  regularHeadline,
  descriptionText,
  richTextHeadline,
  richTextDescription,
  rightSideImage,
  showCta,
  ctaLink,
  ctaLabel,
  ctaLinkTarget,
  heroImageAltLabel,
  heroFormat,
  heroHeight,
  ctaLinkTitle,
  ctaSamesiteStyle,
}) {
  //is "" by default, can be changed to "__fullwidth-image" or "__text-only" in episerver
  //when "__fullwidth-image", image must be a full width banner with text beneath
  //when "__text-only", image is hidden and text is styled center.
  const acquiredHeroFormat = SelectionFactoryHelper.getFromSelectionFactory(heroFormat) || ""
  const acquiredLinkTarget = SelectionFactoryHelper.getFromSelectionFactory(ctaLinkTarget) || "_blank"
  const acquiredHeroHeight = SelectionFactoryHelper.getFromSelectionFactory(heroHeight) || "standard-height"

  const isHeightEditable = acquiredHeroFormat == ""

  return (
    <section className={`image-hero-container ${acquiredHeroFormat} ${isHeightEditable ? acquiredHeroHeight : ""} `}>
      <div className="w--normal">
        <div className="grid nowrap">
          <div className="grid-item col--12 textside">
            <div className="text-container">
              <div data-epi-property="PreHeaderText" className="infohead">
                {preHeaderText}
              </div>

              {richTextHeadline ? (
                ReactHtmlParser(richTextHeadline)
              ) : (
                <h1 data-epi-property="BoldHeadline">
                  <strong>{boldHeadline}</strong> {regularHeadline}
                </h1>
              )}
              <div data-epi-property="DescriptionText" className="maintext rich-text">
                <div className="description-text-container">
                  {richTextDescription ? ReactHtmlParser(richTextDescription) : <p data-epi-property="DescriptionText">{descriptionText}</p>}
                </div>
                {showCta ? (
                  <div className="buttoncontainer">
                    <a
                      title={ctaLinkTitle}
                      target={acquiredLinkTarget}
                      href={ctaLink}
                      className={ctaSamesiteStyle ? "samesite-style" : "button button--medium button--general no-shadow has-icon"}
                    >
                      <span data-epi-property="CtaLabel" className="text">
                        {ctaLabel}
                      </span>
                      <span className="ctaarrow"></span>
                    </a>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="grid-item col--12 no-margin">
            <div className="image-container">
              <img data-epi-property="RightSideImage" alt={heroImageAltLabel} src={rightSideImage}></img>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ImageHero
